import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Terms() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // or "smooth"
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#050A07] text-white">
      <Header />

      <main className="max-w-4xl mx-auto px-6 md:px-10 pt-32 pb-16">
        <section className="reveal">
          <div className="glass-card p-8">
            <h1 className="text-3xl font-bold gradient-text-saffron mb-4">
              Terms & Trade Notice
            </h1>

            <p className="text-sm text-white/70 mb-4">
              Please read the following important information about our trading operations.
            </p>

            <div className="space-y-4 text-sm text-white/60">
              <p>
                - Indian Eco Fuels currently trades in biofuels on a Memorandum of
                Understanding (MOU) basis with partners and suppliers.
              </p>

              <p>
                - We do not currently own or operate any production plants. All supply
                and delivery arrangements are managed through our partner network under
                agreed MOUs.
              </p>

              <p>
                This page provides a transparent summary of our current commercial posture.
                For specific enquiries about partnerships or supply, please contact us at{" "}
                <a
                  href="mailto:contact@indianecofuels.co"
                  className="text-eco-light"
                >
                  contact@indianecofuels.co
                </a>.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}